import { render, staticRenderFns } from "./ParentConsentPopup.vue?vue&type=template&id=d9ab1668"
import script from "./ParentConsentPopup.vue?vue&type=script&lang=ts"
export * from "./ParentConsentPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports